export const VIEW_USER_DENIED =
  'You do not have the permission to view this account';
